@reference "../styles/ui.css";

.hsp-select {
  /* &:global(.is-invalid) {
      :global(div.select__control) {
        border-color: $danger;

        &:global(.select__control--is-focused) {
          box-shadow: 0 0 0 1px $danger;
        }
      }
    }

    .hsp-select-group {
      font-size: 1em;
    }

    .hsp-select-group-heading {
      @include t.theme(true) using($theme-map) {
        background-color: t.theme-value($theme-map, "group-background-color");
        color: t.theme-value($theme-map, "group-color");
      }
      font-size: $h6-font-size !important;
      font-weight: $font-weight-bold !important;
      padding: 0.5rem;

      &.header {
        cursor: pointer;
      }
    }

    .hsp-select-hidden {
      @include m.flex-center-vert;

      @include t.theme(true) using($theme-map) {
        background-color: t.theme-value($theme-map, "hidden-background-color");
        color: t.theme-value($theme-map, "hidden-color");
      }
      border-radius: $border-radius-sm;
      font-size: 85%;
      padding: 3px 6px;
    }

    .hsp-select-is-fixed {
      background-color: $gray-600;
      font-weight: bold;

      :global([class*="__multi-value__label"]) {
        color: $gray-100;
        padding-right: 6px;
      }
    }

    .hsp-select-option {
      @include m.flex-center-vert;
      @include t.theme(true) using($theme-map) {
        padding: t.theme-value($theme-map, "option-padding");
      }
      transition: background-color 60ms;

      &:hover {
        @include t.theme(true) using($theme-map) {
          background-color: t.theme-value($theme-map, "option-background-color");
        }
        transition-delay: 60ms;
      }

      &.select__option {
        &.select__option--is-focused {
          @include t.theme(true) using($theme-map) {
            background-color: t.theme-value($theme-map, "option-background-color-focused");
          }
        }

        &.select__option--is-selected {
          @include t.theme(true) using($theme-map) {
            background-color: t.theme-value($theme-map, "option-background-color-selected");
          }
        }
      }
    }

    .hsp-select-virtual-menu-list {
      .hsp-select-virtual-menu-wrapper {
        @include m.relative;

        width: 100%;
      }

      .hsp-select-virtual-option-wrapper {
        @include m.absolute(left 0 right 0 top 0);
      }
    }
  } */
}

.hsp-select [class^="group_"]:not(:last-child),
:global(.hsp-select__menu-portal [class^="group_"]:not(:last-child)) {
  @apply mb-1;
}

.hsp-select :global(.hsp-select__placeholder) {
  color: rgb(26, 32, 44);
  @apply leading-6 min-w-0 truncate;
}

:global(body .hsp-select__menu-portal) {
  /* @apply z-[9999] */
}

/**********************************************************************************************************************
 * OPTIONS
 *********************************************************************************************************************/
.hsp-select :global(.hsp-select-option),
:global(.hsp-select__menu-portal .hsp-select-option) {
  @apply p-0 truncate transition-colors delay-75;
}

.hsp-select :global(.hsp-select-option span),
:global(.hsp-select__menu-portal .hsp-select-option span) {
  @apply px-4 py-2 truncate w-full;
}

.hsp-select:global(.is-invalid) {
  :global(.hsp-select__control) {
    @apply border-red-500 shadow-[0_0_0_1px_var(--tw-shadow-color)] !shadow-red-500;
  }
}

:global(.hsp-select__menu-portal .hsp-select-option:hover) {
  @apply bg-blue-200 delay-75;
}

:global(.hsp-select__menu-portal .hsp-select-option.hsp-select__option--is-focused) {
  @apply bg-blue-100;
}

:global(.hsp-select__menu-portal .hsp-select-option.hsp-select__option--is-selected) {
  @apply bg-blue-500 text-white;
}
